import { BaseDto } from './base.dto';

export class CuisineDto extends BaseDto {
  name: string;
  startDate: Date;
  endDate: Date;
  imageURL: string;
}
